export default __webpack_public_path__ + "static/media/demoProfile.9434f94a.svg";